export default __webpack_public_path__ + "static/media/Yi_New_Logo.823e6d56.png";